import loginStyles from '../Login/Login.module.css';
import { AuthPageShell } from '../Login/AuthPageShell';
import { motion } from 'framer-motion';
import SVGChecked from '../../helpers/SVG/SVGRadio/SVGChecked';
import SVGUnchecked from '../../helpers/SVG/SVGRadio/SVGUnchecked';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export function SelectVerifyMethod() {
  const navigate = useNavigate();
  const [option, setOption] = useState('');

  return (
    <AuthPageShell variant='center'>
      <div className={loginStyles.authFlowMax}>
        <motion.main className={`${loginStyles.main} ${loginStyles.mainWide}`} initial={false}>
          <div className={loginStyles.formEyebrow}>Security</div>
          <div className={loginStyles.formTitle}>Two-factor authentication</div>
          <p className={loginStyles.forgotText}>
            You have enabled email and phone for two-factor authentication. Select one of these
            options to continue.
          </p>
          <div className={loginStyles.authOptionsStack}>
            <button
              type='button'
              className={loginStyles.authSelectRow}
              onClick={() => setOption('email')}
            >
              {option === 'email' ? <SVGChecked /> : <SVGUnchecked />}
              <div className={loginStyles.authSelectLabel}>
                Receive a verification code at your registered email address
              </div>
            </button>
            <button
              type='button'
              className={loginStyles.authSelectRow}
              onClick={() => setOption('phone')}
            >
              {option === 'phone' ? <SVGChecked /> : <SVGUnchecked />}
              <div className={loginStyles.authSelectLabel}>
                Get a verification code via SMS on your registered phone number
              </div>
            </button>
          </div>
          <button
            type='button'
            disabled={!option}
            className={`${loginStyles.submitBtn} ${!option ? loginStyles.disableBtn : ''}`}
            onClick={() => {
              navigate(`/two-factor-authentication/${option}`);
            }}
          >
            <span>Continue</span>
          </button>
        </motion.main>
      </div>
    </AuthPageShell>
  );
}
